import { networkRequest } from '@tencent/ark-request';
var NetworkRequestService = /** @class */ (function () {
    function NetworkRequestService() {
        this.instance = networkRequest;
    }
    return NetworkRequestService;
}());
export { NetworkRequestService };
